<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    @if (formGroup.get('guid').value) {
      {{ formGroup.get('target').value }}
    } @else {
      {{ 'partnerNote.company' | translate }}
    }
  </div>
  <form [formGroup]="formGroup"
    (ngSubmit)="save()">
    @if (newContact()) {
      <ion-label>{{ 'partnerNote.contact' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-input autocapitalize="on"
          formControlName="contact"></ion-input>
      </ion-item>
      <ion-label>{{ 'partnerNote.contactType' | translate }}</ion-label>
      <div class="ion-margin-top ion-margin-bottom">
        <ion-radio-group formControlName="contactType">
          @for (contactType of contactTypes; track contactType) {
            <ion-radio [value]="contactType"
              labelPlacement="end">
              {{ 'partnerNote.contactTypes.' + contactType | translate }}
            </ion-radio>
          }
        </ion-radio-group>
      </div>
      <ion-label>{{ 'partnerNote.interested' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="interested"
          rows="2"></ion-textarea>
      </ion-item>
      <ion-label>{{ 'partnerNote.future' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="future"
          rows="2"></ion-textarea>
      </ion-item>
    } @else {
      <ion-label>{{ 'partnerNote.target' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-input autocapitalize="on"
          formControlName="target"></ion-input>
      </ion-item>
      <ion-label>{{ 'partnerNote.information' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="information"></ion-textarea>
      </ion-item>
      <ion-label>{{ 'site.notes' | translate }}</ion-label>
      <ion-item lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="notes"></ion-textarea>
      </ion-item>
      <ion-item lines="none">
        <ion-toggle formControlName="sendNotification">{{ 'partnerNote.sendNotification' | translate }}</ion-toggle>
        @if (formGroup.get('sendNotification').value) {
          <app-select-day [value]="formGroup.get('notificationDate').value"
            (changed)="onNotificationDate($event)">{{ 'partnerNote.notificationDate' | translate }}</app-select-day>
        }
      </ion-item>
    }
    @if (['done', 'contractSend', 'meeting'].includes(formGroup.get('status').value)) {
      <div class="tw:flex tw:items-center tw:justify-between">
        <ion-label>{{ 'partnerNote.startDate' | translate }}</ion-label>
        <app-select-day color="secondary"
          [id]="'startDate'"
          [name]="'partnerNote.startDate'"
          size="medium"
          [value]="formGroup.get('startDate').value"
          (changed)="onDateChange($event, 'startDate')"></app-select-day>
        <ion-label>{{ 'partnerNote.trainingDate' | translate }}</ion-label>
        <app-select-day color="secondary"
          [id]="'trainingDate'"
          [name]="'partnerNote.trainingDate'"
          size="medium"
          [value]="formGroup.get('trainingDate').value"
          (changed)="onDateChange($event, 'trainingDate')"></app-select-day>
      </div>
    }
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        expand="full"
        type="submit"
        [disabled]="!formGroup.valid">{{ 'general.save' | translate }}</ion-button>
      @if (formGroup.get('status').value === 'contractSend') {
        <ion-button color="success"
          shape="round"
          (click)="onStatus('done')">
          {{ 'partnerNote.done' | translate }}
        </ion-button>
        <ion-button color="danger"
          shape="round"
          (click)="onStatus('archived')">
          {{ 'partnerNote.archive' | translate }}
        </ion-button>
      }
    </div>
  </form>
  @if (history().length > 0) {
    <h4>{{ 'partnerNote.saleStatus' | translate }}</h4>
    <app-segment-list [segmentValue]="formGroup.get('status').value"
      [segmentButtons]="statusSegmentButtons"
      (segmentChanged)="statusSegmentChanged($event)"></app-segment-list>
    <h4>{{ 'partnerNote.history' | translate }}</h4>
    <div>
      <ion-button color="light"
        (click)="onNew()">
        {{ 'partnerNote.add' | translate }}
      </ion-button>
      @if (!['prospect', 'done', 'archived', 'deleted'].includes(formGroup.get('status').value)) {
        <ion-button color="light"
          shape="round"
          (click)="onOffer()">
          {{ 'offer.offer' | translate }}
        </ion-button>
        <ion-button color="light"
          shape="round"
          (click)="onContract()">
          {{ 'offer.contractNote' | translate }}
        </ion-button>
      }
      @if (!['done', 'archived', 'deleted'].includes(formGroup.get('status').value)) {
        <ion-button color="light"
          shape="round"
          (click)="onStatus('notInterested')">
          {{ 'live.status.notInterested' | translate }}
        </ion-button>
        <ion-button color="light"
          shape="round"
          (click)="onStatus('didNotAnswer')">
          {{ 'live.status.didNotAnswer' | translate }}
        </ion-button>
      }
      @if (formGroup.get('status').value === 'done' && formGroup.get('contractor').value == null) {
        <ion-button color="light"
          shape="round"
          (click)="openServices()">
          {{ 'partnerNote.openServices' | translate }}
        </ion-button>
      }
    </div>
    @for (item of history(); track $index) {
      <ion-item lines="none">
        <span slot="start">
          {{ item.date | timestamp:'d.M.yyyy HH:mm' }}
        </span>
        <div>
          {{ 'live.status.' + item.status | translate }}<br />
          <ion-note>{{ item.user.name }}</ion-note>
          @if (item.show) {
            <div>
              {{ item.interested }}<br />
              {{ item.future }}
            </div>
          }
        </div>
        @if (item.future?.length > 0 || item.interested?.length > 0) {
          <ion-button slot="end"
            (click)="item.show = !item.show">
            @if (item.show) {
              <ion-icon slot="icon-only"
                name="eye-outline"></ion-icon>
            } @else {
              <ion-icon slot="icon-only"
                name="eye-off-outline"></ion-icon>
            }
          </ion-button>
        }
      </ion-item>
    }
  }
  @if (formGroup.get('guid').value) {
    <div class="ion-margin-top">
      <ion-button color="danger"
        shape="round"
        (click)="onStatus('deleted')">
        {{ 'site.archive' | translate }}
      </ion-button>
      @if (roleS() === 'super-admin') {
        <app-select-user-button [items]="premiumPartners$ | async"
          (selected)="changeUser($event)"></app-select-user-button>
      }
    </div>
  }
</app-main-dialog>